import { InjectionToken } from '@angular/core';

export const REALTIME_WS_URL = new InjectionToken<string>('REALTIME_WS_URL', {
  factory: () => '',
});

export const REALTIME_COLLABORATION_FEATURE_FLAG = 'realtime-collaboration';

/** @deprecated Use REALTIME_WS_URL */
export const TIMELINE_REALTIME_WS_URL = REALTIME_WS_URL;
